import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [apiUrl, setApiUrl] = useState('');
  const [secret, setSecret] = useState('');
  const [meetingID, setMeetingID] = useState('');
  const [fileURL, setFileURL] = useState('');
  const [meetings, setMeetings] = useState([]);
  const [message, setMessage] = useState('');

  const fetchMeetings = async () => {
    setMessage('');
    try {
      const res = await axios.post(`${backendUrl}/getMeetings`, { apiUrl, secret });
      const parser = new DOMParser();
      const xml = parser.parseFromString(res.data, 'text/xml');
      const meetingsXml = xml.getElementsByTagName('meeting');
      const result = Array.from(meetingsXml).map((m) => ({
        id: m.getElementsByTagName('meetingID')[0]?.textContent || '',
        name: m.getElementsByTagName('meetingName')[0]?.textContent || '',
      }));
      setMeetings(result);
      if (result.length && !meetingID) setMeetingID(result[0].id);
    } catch (err) {
      setMessage('Error fetching meetings');
    }
  };

  const sendFile = async () => {
    setMessage('');
    if (!apiUrl || !secret || !meetingID || !fileURL) {
      setMessage('Please fill all fields and select a meeting');
      return;
    }
    try {
      await axios.post(`${backendUrl}/insertDocument`, { apiUrl, secret, meetingID, fileURL });
      setMessage('✅ File sent successfully');
    } catch (err) {
      setMessage('❌ Failed to send file');
    }
  };

  return (
    <div className="container">
      <header>
        <h1>Insert Presentation to Live BigBlueButton Meetings</h1>
        <p className="description">
          Fetch BigBlueButton Sessions & Upload Presentations or Files Directly to any Live Session, using API URL & Secret — no login required.
        </p>
      </header>
      <form>
        <label htmlFor="apiUrl">BigBlueButton API URL</label>
        <input
          id="apiUrl"
          name="apiUrl"
          autoComplete="on" // Use "on" for generic autofill
          placeholder="https://yourbbbdomain.com/bigbluebutton/api"
          type="url"
          value={apiUrl}
          onChange={(e) => setApiUrl(e.target.value)}
        />
        <label htmlFor="secret">BigBlueButton Secret</label>
        <input
          id="secret"
          name="secret"
          autoComplete="on" // Use "on" for generic autofill
          placeholder="jFcLXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
          type="text"
          value={secret}
          onChange={(e) => setSecret(e.target.value)}
        />
        <button type="button" onClick={fetchMeetings}>
          Fetch Meetings
        </button>
        <label htmlFor="meetingID">Select a Meeting</label>
        <select
          id="meetingID"
          name="meetingID"
          title="Select a live meeting from the dropdown"
          value={meetingID}
          onChange={(e) => setMeetingID(e.target.value)}
        >
          <option value="">Select a Meeting</option>
          {meetings.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name || m.id}
            </option>
          ))}
        </select>
        <label htmlFor="fileURL">Public File URL</label>
        <input
          id="fileURL"
          name="fileURL"
          autoComplete="on" // Use "on" for generic autofill
          placeholder="Enter the public file URL"
          title="Enter the public URL of the file you want to upload (e.g., a shared PDF link)"
          value={fileURL}
          onChange={(e) => setFileURL(e.target.value)}
        />
        <button type="button" onClick={sendFile} disabled={!meetingID || !fileURL}>
          Send File
        </button>
        <p className={message.startsWith('✅') ? 'success' : 'error'}>{message}</p>
      </form>
      <footer>
        <p>
          Powered by <a href="https://bigbluebutton.host/" target="_blank" rel="noopener noreferrer">BigBlueButton Host</a> — Managed Hosting, Installation & Support
        </p>
      </footer>
    </div>
  );
}

export default App;
